import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import request from 'src/utils/request'

const initialState = {
  isLoading: false,
  isSuccess: false,
  modeleMatriculeData: [],
  error: '',
}

export const getModeleMatriculeList = createAsyncThunk(
  'modeleMatricule/getModeleMatriculeList',
  async (_, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.user.token
      const res = await request(token).get(`/tables/modele-matricule`)
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const modeleMatriculeSlice = createSlice({
  name: 'modeleMatricule',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getModeleMatriculeList.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(getModeleMatriculeList.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.modeleMatriculeData = action.payload
        state.error = ''
      })
      .addCase(getModeleMatriculeList.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
  },
})

export default modeleMatriculeSlice.reducer
